import { Component, OnInit } from '@angular/core';
import {RatingsPageService} from "../../../services/ratings-page.service";
@Component({
  selector: 'app-ratings-page-header',
  templateUrl: './ratings-page-header.component.html',
  styleUrls: ['./ratings-page-header.component.scss']
})
export class RatingsPageHeaderComponent implements OnInit {

  constructor(
    private ratingsPageService: RatingsPageService,
  ) { }
  public labelsOptionsAndHandlers = [
    {
      label: 'Год',
      optionsList: [
        {
          a: '1805',
        },
        {
          a: '1812',
        },
        {
          a: '1914',
        },
      ],
      selectedOption: null,
      optionTransformer: (option) => option?.a,
    },
    {
      label: 'Игра',
      optionsList: [
        {
          a: 'Аустерлиц',
        },
        {
          a: 'Бородино',
        },
        {
          a: 'Марна',
        },
      ],
      selectedOption: null,
      optionTransformer: (option) => option?.a,
    },
    {
      label: 'Статус',
      optionsList: [
        {
          a: 'Выйграно',
        },
        {
          a: 'Проиграно',
        },
        {
          a: 'Сдержанно',
        },
      ],
      selectedOption: null,
      optionTransformer: (option) => option?.a,
    },
    {
      label: 'Тип организации',
      optionsList: [
        {
          a: 'Клуб империалистов',
        },
        {
          a: 'Клуб империалистов',
        },
        {
          a: 'Клуб империалистов',
        },
      ],
      selectedOption: null,
      optionTransformer: (option) => option?.a,
    },
    {
      label: 'Название организации',
      optionsList: [
        {
          a: 'Французская Империя',
        },
        {
          a: 'Российская Империя',
        },
        {
          a: 'Французская Республика',
        },
      ],
      selectedOption: null,
      optionTransformer: (option) => option?.a,
    },
    {
      label: 'Страна',
      optionsList: [
        {
          a: 'Австрия',
        },
        {
          a: 'Россия',
        },
        {
          a: 'Франция',
        },
      ],
      selectedOption: null,
      optionTransformer: (option) => option?.a,
    },
    {
      label: 'Город',
      optionsList: [
        {
          a: 'Поле',
        },
        {
          a: 'Поле',
        },
        {
          a: 'Поле',
        },
      ],
      selectedOption: null,
      optionTransformer: (option) => option?.a,
    },
  ];
  ngOnInit(): void {

  }

  ratingCreateButtonIsAvailable(): boolean {
    console.debug('this.ratingsPageService.isStaff value', this.ratingsPageService.isStaff);
    return this.ratingsPageService.isStaff;
  }

  createRatingRedirector() {
    window.open('/rating-editor?edit=false', '_self');
  }

  public testOptions: string[] = [
    'list1',
    'list2',
    'list3',
    'list4',
    'list5',
    'list6',
  ];

}
